module.exports = __webpack_public_path__ + "static/media/corona.25511f69.fasta";